import { render } from "./EditConfig.vue?vue&type=template&id=ebc752d4&scoped=true"
import script from "./EditConfig.vue?vue&type=script&lang=js"
export * from "./EditConfig.vue?vue&type=script&lang=js"

import "./EditConfig.vue?vue&type=style&index=0&id=ebc752d4&scoped=true&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc752d4"]])

export default __exports__